import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  addSetupDetailsBusiness,
  addSetupDetailsPersonal,
  signInWithEmail,
  signUpWithGoogle,
  storage,
} from "../../firebase/firebase";
import { Alert, CircularProgress } from "@mui/material";
import "../../css/signup.css";
import halfglobe from "../../assets/halfglobe.png";
import userIcon from "../../assets/uicon.png";
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";

const Setup = () => {
  // use location
  const location = useLocation();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [typeOfAcct, setTypeOfAcct] = useState("Personal");
  const [error, setError] = useState("");
  const [value, setValue] = useState({
    companyName: "",
    companyAddress: "",
    businessLogoUrl: "",
    imageLogo: "",
    businessType: "",
    selectedCountry: "",
    telephone: "",
    createdAt: new Date().toISOString().split("T")[0],
    website: "",
  });
  const [values, setValues] = useState({
    name: "",
    url: "",
    phone: "",
    businessLogoUrl: "",
    imageLogop: "",
  });

  // check for acct type
  const checkSelected = (e) => {
    console.log(e.target.value);
    setTypeOfAcct(e.target.value);
  };

  // handle input change
  const handleChange = (e) => {
    console.log(e.target.value);
    setValue({
      ...value,
      businessType: e.target.value,
    });
  };

  // handle submit
  const handleSubmit = (e) => {
    e.preventDefault();
    completeOnboarding();
  };

  // values
  const { imageLogo } = value;
  const { imageLogop } = values;

  // image input ref
  const userImage = useRef(null);

  const uploadImage = async () => {
    try {
      const file = userImage.current.files[0];
      if (!file) return;
      setIsLoading(true);
      const storageRef = ref(storage, `files/${file.name}`);
      const uploadTask = uploadBytesResumable(storageRef, file);

      uploadTask.on("state_changed", () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          if (downloadURL) {
            setIsLoading(false);
          }
          setValues({
            ...values,
            businessLogoUrl: downloadURL,
          });
          setValue({
            ...value,
            businessLogoUrl: downloadURL,
          });
          console.log(downloadURL);
        });
      });
    } catch (eror) {}
  };

  // showing images
  const addImage = async (e) => {
    const readerImg = new FileReader();
    if (e.target.files[0]) {
      readerImg.readAsDataURL(e.target.files[0]);
    }

    readerImg.onload = (readerEvent) => {
      setValue({
        ...value,
        imageLogo: readerEvent.target.result,
      });
    };
  };

  const profileImage = async (e) => {
    const reader = new FileReader();
    if (e.target.files[0]) {
      reader.readAsDataURL(e.target.files[0]);
    }

    reader.onload = (readerEvent) => {
      setValues({
        ...values,
        imageLogop: readerEvent.target.result,
      });
    };
  };

  // complete setup
  const completeOnboarding = async () => {
    try {
      if (typeOfAcct === "Personal") {
        if (!values.businessLogoUrl) {
          setError("Kindly wait for profileimage to upload");
          return;
        }
        addSetupDetailsPersonal(location.state.email, values).then(() => {
          navigate("/dashboard", { state: { email: location.state.email } });
        });
      } else {
        if (!value.businessLogoUrl) {
          setError("Kindly wait for image to upload");
          return;
        }
        addSetupDetailsBusiness(location.state.email, value).then(() => {
          navigate("/dashboard", { state: { email: location.state.email } });
        });
      }
    } catch (error) {
      let err = error.message.substring(9);
      setError(err);
      console.log(error.message);
    }
  };

  // useeffect for uploading image
  useEffect(() => {
    uploadImage();
    // eslint-disable-next-line
  }, [imageLogo || imageLogop]);

  return (
    <>
      {isLoading ? (
        <div className="absolute z-50 w-full h-full">
          <div className="flex items-center w-full h-full justify-center">
            <CircularProgress />
          </div>
        </div>
      ) : (
        <></>
      )}
      <div className="reg bg-gradient-to-br from-[#060409] to-[#361e42]">
        <div className="reg-1">
          <div className="w-full my-auto h-full">
            <div className="flex items-center w-full h-full justify-center ">
              <img src={halfglobe} alt="globe" className="absolute bottom-0 left-0" />
            </div>
          </div>
        </div>
        <div className="reg-2">
          <div className="reg-21">
            <div>
              <div className="reg-213">
                <h1 className="text-2xl font-semibold pt-1 pb-1 lg:pl-6 text-white font-Varela">
                  SIGN-UP
                </h1>
                <p className="text-slate-500 text-sm  lg:pl-6 gg">
                  Setup your paytron account
                </p>
                <div className="create-acct">
                  <form onSubmit={handleSubmit}>
                    <div className=" space-y-3 pt-6">
                      <div className="flex flex-col ">
                        <label className="text-sm font-normal py-2 leading-4 text-white">
                          Account Type
                        </label>
                        <select
                          id="accounttype"
                          onChange={checkSelected}
                          className="pl-[1.5rem] pr-[1.5rem] text-sm p-[2px] font-semibold cursor-pointer"
                        >
                          <option>Personal</option>
                          <option>Business / Organization</option>
                        </select>
                      </div>
                      {typeOfAcct === "Personal" ? (
                        <>
                          <div className="space-y-4 py-4">
                            <div>
                              <label className="text-sm font-normal py-2 leading-4 text-white">
                                Full Name
                              </label>
                              <input
                                id="name"
                                type="name"
                                className="py-2 w-full p-2 text-sm"
                                name="name"
                                placeholder="Full Name"
                                onChange={(e) =>
                                  setValues({
                                    ...values,
                                    name: e.target.value,
                                  })
                                }
                                required
                              />
                            </div>
                            <div>
                              <label className="text-sm font-normal py-2 leading-4 text-white">
                                Twitter Url
                              </label>
                              <input
                                id="twitter"
                                type="twitter"
                                className="py-2 w-full p-2 text-sm"
                                name="twitter"
                                placeholder="Twitter Url"
                                onChange={(e) =>
                                  setValues({
                                    ...values,
                                    url: e.target.value,
                                  })
                                }
                                required
                              />
                            </div>
                            <div>
                              <label className="text-sm font-normal py-2 leading-4 text-white">
                                Mobile Phone
                              </label>
                              <input
                                id="mobile"
                                type="mobile"
                                className="py-2 w-full p-2 text-sm"
                                name="mobile"
                                placeholder="Mobile Phone"
                                onChange={(e) =>
                                  setValues({
                                    ...values,
                                    phone: e.target.value,
                                  })
                                }
                                required
                              />
                            </div>
                            <div className="py-6 space-y-6">
                              <div>
                                {imageLogop ? (
                                  <div className=" w-24 h-24">
                                    <img
                                      src={imageLogop}
                                      alt="imagelogo"
                                      className="lg:w-full w-2/5"
                                    />
                                  </div>
                                ) : (
                                  <>
                                    <div className="lg:w-24 lg:h-24">
                                      <img
                                        src={userIcon}
                                        alt="usericon"
                                        className="lg:w-full w-2/5"
                                      />
                                    </div>
                                  </>
                                )}
                              </div>
                              <input
                                ref={userImage}
                                hidden
                                onChange={profileImage}
                                type="file"
                                accept=".jpg, .jpeg, .png"
                              />
                              <div
                                className=""
                                onClick={() => userImage.current.click()}
                              >
                                <p className="text-sm bg-[#222222] py-3 lg:p-2 lg:w-fit px-6 rounded-md cursor-pointer text-[#F3EFE0]">
                                  Upload your profile picture
                                </p>
                              </div>
                            </div>
                            <button className="flex justify-center mb-7 items-center w-full cursor-pointer p-3 font-medium text-center rounded-3xl text-sm">
                              Complete Setup
                            </button>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="space-y-4 py-4">
                            <div>
                              <label className="text-sm font-normal py-2 leading-4 text-white">
                                Company's Name
                              </label>
                              <input
                                id="company"
                                type="company"
                                className="py-2 w-full p-2 text-sm"
                                name="company"
                                placeholder="Company's Name"
                                onChange={(e) =>
                                  setValue({
                                    ...value,
                                    companyName: e.target.value,
                                  })
                                }
                                required
                              />
                            </div>
                            <div>
                              <label className="text-sm font-normal py-2 leading-4 text-white">
                                Company's Address
                              </label>
                              <input
                                id="address"
                                type="address"
                                className="py-2 w-full p-2 text-sm"
                                name="address"
                                placeholder="Company's Address"
                                onChange={(e) =>
                                  setValue({
                                    ...value,
                                    companyAddress: e.target.value,
                                  })
                                }
                                required
                              />
                            </div>
                            <div>
                              <label className="text-sm font-normal py-2 leading-4 text-white">
                                Telephone
                              </label>
                              <input
                                id="telephone"
                                type="telephone"
                                className="py-2 w-full p-2 text-sm"
                                name="telephone"
                                placeholder="TelePhone"
                                onChange={(e) =>
                                  setValue({
                                    ...value,
                                    telephone: e.target.value,
                                  })
                                }
                                required
                              />
                            </div>
                            <div>
                              <label className="text-sm font-normal py-2 leading-4 text-white">
                                Website
                              </label>
                              <input
                                id="website"
                                type="website"
                                className="py-2 w-full p-2 text-sm"
                                name="website"
                                placeholder="Website url"
                                onChange={(e) =>
                                  setValue({
                                    ...value,
                                    website: e.target.value,
                                  })
                                }
                                required
                              />
                            </div>
                            <div>
                              <label className="text-sm font-normal py-2 leading-4 text-white">
                                Country
                              </label>
                              <input
                                id="country"
                                type="country"
                                className="py-2 w-full p-2 text-sm"
                                name="country"
                                placeholder="Country"
                                onChange={(e) =>
                                  setValue({
                                    ...value,
                                    selectedCountry: e.target.value,
                                  })
                                }
                                required
                              />
                            </div>
                            <div>
                              <label className="text-sm font-normal py-2 leading-4 text-white mr-1">
                                Business Type
                              </label>
                              <select
                                id="Bustype"
                                onChange={handleChange}
                                className="pl-[1.5rem] pr-[1.5rem] text-sm p-[2px] font-semibold"
                              >
                                <option>Retailer</option>
                                <option>Health Practitioner</option>
                                <option>Distributor (Finished Goods)</option>
                                <option>Food Service</option>
                                <option>
                                  Supplier/Raw Ingredient Distributor
                                </option>
                                <option>Manufacturer</option>
                                <option>Business Services</option>
                                <option>Investor</option>
                              </select>
                            </div>
                            <div className="py-6 lg:space-y-6 space-y-16">
                              <div>
                                {imageLogo ? (
                                  <div className=" w-24 h-24">
                                    <img
                                      src={imageLogo}
                                      alt="imagelogo"
                                      className=" w-2/5 lg:w-full"
                                    />
                                  </div>
                                ) : (
                                  <>
                                    <div className=" w-24 h-24">
                                      <img
                                        src={userIcon}
                                        alt="usericon"
                                        className="w-2/5 lg:w-full"
                                      />
                                    </div>
                                  </>
                                )}
                              </div>
                              <input
                                ref={userImage}
                                hidden
                                onChange={addImage}
                                type="file"
                                className="bg-red-500 w-24 h-24"
                                accept=".jpg, .jpeg, .png"
                              />
                              <div onClick={() => userImage.current.click()}>
                                <p className="text-sm bg-[#222222] p-2 lg:w-fit lg:px-6 rounded-md cursor-pointer text-[#F3EFE0]">
                                  Upload your business Logo
                                </p>
                              </div>
                            </div>
                            <button className="flex justify-center mb-7 items-center w-full cursor-pointer p-3 font-medium text-center rounded-3xl text-sm">
                              Complete Setup
                            </button>
                          </div>
                        </>
                      )}
                    </div>
                  </form>
                </div>
              </div>
              <div
                className={
                  error === "" ? `hidden` : `absolute bottom-4 right-4`
                }
              >
                <Alert severity="error">{error}</Alert>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Setup;
